/* =================================================================
   IT'S RADGE — Theme JS v2.0
   "Particle wizards, retro chaos, AJAX cart glory"
   ================================================================= */

window.RadgeTheme = (function() {
  'use strict';

  /* ── CART ──────────────────────────────────────────────────────── */
  const Cart = {
    drawer: null,
    overlay: null,
    countEl: null,

    init() {
      this.drawer  = document.getElementById('cart-drawer');
      this.overlay = document.getElementById('cart-overlay');
      this.countEl = document.getElementById('cart-count');

      // Open triggers
      document.querySelectorAll('#cart-btn, #cart-btn-mobile').forEach(btn => {
        btn.addEventListener('click', () => this.open());
      });

      // Close triggers
      document.getElementById('cart-close')?.addEventListener('click',  () => this.close());
      this.overlay?.addEventListener('click', () => this.close());

      // Add to cart forms
      document.addEventListener('click', e => {
        const btn = e.target.closest('.add-to-cart-btn, [data-add-to-cart]');
        if (btn) { e.preventDefault(); this.addFromForm(btn); }
      });

      // Qty controls in drawer
      this.drawer?.addEventListener('click', e => {
        const qtyBtn = e.target.closest('.qty-btn');
        if (qtyBtn) {
          const key = qtyBtn.dataset.key;
          const delta = qtyBtn.dataset.action === 'plus' ? 1 : -1;
          const current = parseInt(qtyBtn.closest('.cart-item')?.querySelector('.qty-val')?.textContent || '1');
          this.updateQty(key, Math.max(0, current + delta));
        }
        const removeBtn = e.target.closest('.cart-remove');
        if (removeBtn) this.updateQty(removeBtn.dataset.key, 0);
      });

      this.updateCount();
    },

    open() {
      this.drawer?.classList.add('open');
      this.overlay?.classList.add('open');
      document.body.style.overflow = 'hidden';
      this.refresh();
    },

    close() {
      this.drawer?.classList.remove('open');
      this.overlay?.classList.remove('open');
      document.body.style.overflow = '';
    },

    async addFromForm(btn) {
      const form = btn.closest('form') || btn.closest('[data-product-form]');
      if (!form) return;
      const formData = new FormData(form);
      const variantId = formData.get('id') || btn.dataset.variantId;
      if (!variantId) return;

      btn.disabled = true;
      btn.textContent = 'ADDING...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: variantId, quantity: parseInt(formData.get('quantity') || '1') })
        });
        if (!res.ok) throw new Error('Add to cart failed');
        await this.refresh();
        Toast.show('Added to cart! 🧙', 'success');
        this.open();
      } catch (err) {
        Toast.show('Oops! Something went wrong', 'error');
      } finally {
        btn.disabled = false;
        btn.textContent = btn.dataset.originalText || 'ADD TO CART';
      }
    },

    async updateQty(key, qty) {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        if (!res.ok) throw new Error();
        await this.refresh();
      } catch(e) {
        Toast.show('Could not update cart', 'error');
      }
    },

    async refresh() {
      try {
        const res  = await fetch('/cart.js');
        const cart = await res.json();
        this.updateCount(cart.item_count);
        this.renderItems(cart);
      } catch(e) {}
    },

    updateCount(count) {
      const el = document.getElementById('cart-count');
      if (!el) return;
      if (count === undefined) {
        fetch('/cart.js').then(r => r.json()).then(c => this.updateCount(c.item_count));
        return;
      }
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    },

    renderItems(cart) {
      const body   = document.getElementById('cart-drawer-body');
      const footer = document.getElementById('cart-drawer-footer');
      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML = `
          <div class="cart-empty-state">
            <div style="margin-bottom:16px">${'<svg width="80" height="80" viewBox="0 0 64 80" xmlns="http://www.w3.org/2000/svg"><rect x="26" y="1" width="4" height="3" fill="#9d00ff"/><rect x="24" y="4" width="8" height="3" fill="#1a0030"/><rect x="22" y="7" width="12" height="3" fill="#1a0030"/><rect x="20" y="10" width="16" height="3" fill="#160028"/><rect x="16" y="13" width="22" height="3" fill="#0e001e"/><rect x="20" y="11" width="14" height="3" fill="#9d00ff"/><rect x="22" y="16" width="14" height="12" fill="#f5c4a1"/><rect x="24" y="20" width="4" height="3" fill="#00d4ff"/><rect x="30" y="20" width="4" height="3" fill="#00d4ff"/><rect x="26" y="25" width="6" height="2" fill="#6a2a00"/><rect x="29" y="23" width="3" height="2" fill="#6a2a00"/><rect x="18" y="28" width="20" height="20" fill="#1a0030"/><rect x="18" y="36" width="20" height="3" fill="#9d00ff" opacity="0.8"/><rect x="40" y="8" width="3" height="36" fill="#ffd700"/><rect x="37" y="4" width="8" height="8" fill="#ff006e" opacity="0.9"/><rect x="39" y="6" width="4" height="4" fill="#ffffff" opacity="0.9"/><rect x="16" y="47" width="24" height="10" fill="#0e001e"/><rect x="16" y="56" width="24" height="2" fill="#9d00ff" opacity="0.6"/></svg>'}</div>
            <p class="heading-sm" style="color:var(--txt-muted);margin-bottom:20px">YOUR CART IS EMPTY</p>
            <p style="font-family:var(--font-vt);font-size:17px;color:var(--txt-dim);margin-bottom:24px">The wizard is sad. Add some cards.</p>
            <a href="/collections/all" class="btn btn-primary" onclick="RadgeTheme.Cart.close()">SHOP NOW</a>
          </div>`;
        if (footer) footer.style.display = 'none';
        return;
      }

      if (footer) footer.style.display = 'block';

      const items = cart.items.map(item => `
        <div class="cart-item" data-key="${item.key}">
          <img src="${item.image || ''}" alt="${item.title}" class="cart-item-img" loading="lazy">
          <div>
            <p class="cart-item-title">${item.title}</p>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<p style="font-family:var(--font-vt);font-size:15px;color:var(--txt-muted);margin-bottom:4px">${item.variant_title}</p>` : ''}
            <p class="cart-item-price">${this.formatMoney(item.final_line_price)}</p>
            <div class="cart-qty">
              <button class="qty-btn" data-action="minus" data-key="${item.key}" aria-label="Decrease">−</button>
              <span class="qty-val">${item.quantity}</span>
              <button class="qty-btn" data-action="plus"  data-key="${item.key}" aria-label="Increase">+</button>
            </div>
          </div>
          <button class="cart-remove" data-key="${item.key}" aria-label="Remove item">✕</button>
        </div>`).join('');

      body.innerHTML = items;

      // Update subtotal
      const sub = document.getElementById('cart-subtotal-val');
      if (sub) sub.textContent = this.formatMoney(cart.total_price);
    },

    formatMoney(cents) {
      return '£' + (cents / 100).toFixed(2);
    }
  };

  /* ── TOAST ─────────────────────────────────────────────────────── */
  const Toast = {
    container: null,
    init() {
      this.container = document.getElementById('toast-container');
      if (!this.container) {
        this.container = document.createElement('div');
        this.container.id = 'toast-container';
        this.container.className = 'toast-container';
        document.body.appendChild(this.container);
      }
    },
    show(msg, type = 'success') {
      if (!this.container) this.init();
      const t = document.createElement('div');
      t.className = `toast ${type}`;
      t.textContent = msg;
      this.container.appendChild(t);
      setTimeout(() => t.classList.add('exit'), 2800);
      setTimeout(() => t.remove(), 3200);
    }
  };

  /* ── SCROLL REVEAL ─────────────────────────────────────────────── */
  const Reveal = {
    init() {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('revealed');
            observer.unobserve(e.target);
          }
        });
      }, { threshold: .12, rootMargin: '0px 0px -40px 0px' });

      document.querySelectorAll('[data-reveal]').forEach(el => observer.observe(el));
    }
  };

  /* ── MOBILE NAV ─────────────────────────────────────────────────── */
  const MobileNav = {
    panel: null,
    overlay: null,
    init() {
      this.panel = document.getElementById('mobile-nav-panel');
      const hamburger = document.getElementById('hamburger-btn');
      const overlay = document.getElementById('mobile-nav-overlay');

      hamburger?.addEventListener('click', () => {
        const open = this.panel?.classList.toggle('open');
        hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (overlay) overlay.style.display = open ? 'block' : 'none';
      });

      overlay?.addEventListener('click', () => {
        this.panel?.classList.remove('open');
        hamburger?.setAttribute('aria-expanded', 'false');
        overlay.style.display = 'none';
      });
    }
  };

  /* ── WISHLIST ───────────────────────────────────────────────────── */
  const Wishlist = {
    key: 'radge_wishlist',
    get() { try { return JSON.parse(localStorage.getItem(this.key) || '[]'); } catch(e) { return []; } },
    save(list) { try { localStorage.setItem(this.key, JSON.stringify(list)); } catch(e) {} },
    toggle(id) {
      const list = this.get();
      const idx  = list.indexOf(id);
      if (idx > -1) list.splice(idx, 1); else list.push(id);
      this.save(list);
      return idx === -1;
    },
    has(id) { return this.get().includes(id); },
    init() {
      document.addEventListener('click', e => {
        const btn = e.target.closest('.wishlist-btn');
        if (!btn) return;
        e.preventDefault();
        const id = btn.dataset.productId;
        const added = this.toggle(id);
        btn.classList.toggle('active', added);
        Toast.show(added ? 'Added to wishlist 💜' : 'Removed from wishlist', added ? 'success' : '');
      });
      document.querySelectorAll('.wishlist-btn').forEach(btn => {
        if (this.has(btn.dataset.productId)) btn.classList.add('active');
      });
    }
  };

  /* ── LOADER ─────────────────────────────────────────────────────── */
  const Loader = {
    init() {
      const loader = document.getElementById('radge-loader');
      if (!loader) return;
      window.addEventListener('load', () => {
        setTimeout(() => loader.classList.add('hidden'), 600);
      });
      // Fallback
      setTimeout(() => loader?.classList.add('hidden'), 3000);
    }
  };

  /* ── PARALLAX STARS ─────────────────────────────────────────────── */
  const Parallax = {
    init() {
      const sm = document.querySelector('.stars-sm');
      const md = document.querySelector('.stars-md');
      const lg = document.querySelector('.stars-lg');
      if (!sm || !md || !lg) return;

      let ticking = false;
      window.addEventListener('scroll', () => {
        if (ticking) return;
        requestAnimationFrame(() => {
          const y = window.scrollY;
          sm.style.transform = `translateY(${y * 0.1}px)`;
          md.style.transform = `translateY(${y * 0.06}px)`;
          lg.style.transform = `translateY(${y * 0.03}px)`;
          ticking = false;
        });
        ticking = true;
      }, { passive: true });
    }
  };

  /* ── CAROUSEL ───────────────────────────────────────────────────── */
  const Carousel = {
    init() {
      document.querySelectorAll('.carousel-wrapper').forEach(wrapper => {
        const track  = wrapper.querySelector('.carousel-track');
        const prev   = wrapper.querySelector('.carousel-prev');
        const next   = wrapper.querySelector('.carousel-next');
        if (!track) return;

        const cards  = Array.from(track.children);
        if (cards.length === 0) return;

        const visible = window.innerWidth < 600 ? 2 : window.innerWidth < 1024 ? 3 : 4;
        let idx = 0;
        const max = Math.max(0, cards.length - visible);

        function slide() {
          const w = cards[0]?.offsetWidth || 0;
          const gap = 20;
          track.style.transform = `translateX(-${idx * (w + gap)}px)`;
          track.style.transition = 'transform .4s cubic-bezier(.16,1,.3,1)';
        }

        prev?.addEventListener('click', () => { idx = Math.max(0, idx - 1); slide(); });
        next?.addEventListener('click', () => { idx = Math.min(max, idx + 1); slide(); });

        // Touch swipe
        let startX = 0;
        track.addEventListener('touchstart', e => { startX = e.changedTouches[0].clientX; }, { passive: true });
        track.addEventListener('touchend',   e => {
          const diff = startX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 40) { idx = diff > 0 ? Math.min(max, idx+1) : Math.max(0, idx-1); slide(); }
        }, { passive: true });
      });
    }
  };

  /* ── PRODUCT GALLERY ────────────────────────────────────────────── */
  const Gallery = {
    init() {
      const mainImg = document.getElementById('gallery-main-img');
      document.querySelectorAll('.gallery-thumb').forEach(thumb => {
        thumb.addEventListener('click', () => {
          if (mainImg) mainImg.src = thumb.dataset.full || thumb.src;
          document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
        });
      });
    }
  };

  /* ── VARIANT SELECTOR ───────────────────────────────────────────── */
  const Variants = {
    init() {
      document.querySelectorAll('.variant-pill').forEach(pill => {
        pill.addEventListener('click', () => {
          const group = pill.closest('.variant-pills');
          group?.querySelectorAll('.variant-pill').forEach(p => p.classList.remove('active'));
          pill.classList.add('active');
          const variantInput = document.querySelector('[name="id"]');
          if (variantInput && pill.dataset.variantId) {
            variantInput.value = pill.dataset.variantId;
          }
        });
      });
    }
  };

  /* ── COLLECTION FILTERS ─────────────────────────────────────────── */
  const Filters = {
    init() {
      document.querySelectorAll('.filter-option').forEach(opt => {
        opt.addEventListener('click', () => {
          const cb = opt.querySelector('.filter-checkbox');
          cb?.classList.toggle('checked');
        });
      });

      const sortSel = document.querySelector('.sort-select');
      if (sortSel) {
        sortSel.addEventListener('change', () => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', sortSel.value);
          window.location.href = url.toString();
        });
      }
    }
  };

  /* ── CANVAS PARTICLE SYSTEM ─────────────────────────────────────── */
  const Particles = {
    canvas: null,
    ctx: null,
    particles: [],
    animId: null,

    init() {
      const stage = document.querySelector('.wizard-stage');
      if (!stage) return;

      this.canvas = document.createElement('canvas');
      this.canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:2';
      this.canvas.width  = stage.offsetWidth;
      this.canvas.height = stage.offsetHeight;
      stage.appendChild(this.canvas);
      this.ctx = this.canvas.getContext('2d');

      this.spawn(50);
      this.loop();
    },

    spawn(n) {
      const colors = ['#ff006e','#00d4ff','#9d00ff','#ffd700','#39ff14'];
      const cx = this.canvas.width  / 2;
      const cy = this.canvas.height / 2;
      for (let i = 0; i < n; i++) {
        const angle = Math.random() * Math.PI * 2;
        const dist  = 60 + Math.random() * 120;
        this.particles.push({
          x: cx + Math.cos(angle) * dist,
          y: cy + Math.sin(angle) * dist,
          vx: (Math.random() - .5) * .6,
          vy: -(.3 + Math.random() * .8),
          size: 1 + Math.random() * 2.5,
          alpha: .6 + Math.random() * .4,
          decay: .004 + Math.random() * .006,
          color: colors[Math.floor(Math.random() * colors.length)]
        });
      }
    },

    loop() {
      if (!this.ctx) return;
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

      this.particles = this.particles.filter(p => {
        p.x += p.vx; p.y += p.vy;
        p.alpha -= p.decay;
        if (p.alpha <= 0) return false;
        this.ctx.save();
        this.ctx.globalAlpha = p.alpha;
        this.ctx.fillStyle = p.color;
        this.ctx.shadowColor = p.color;
        this.ctx.shadowBlur = 6;
        this.ctx.fillRect(p.x, p.y, p.size, p.size);
        this.ctx.restore();
        return true;
      });

      if (this.particles.length < 30) this.spawn(5);

      this.animId = requestAnimationFrame(() => this.loop());
    }
  };

  /* ── WIZARD BLINK ───────────────────────────────────────────────── */
  const WizardBlink = {
    init() {
      const eyes = document.querySelectorAll('.eye-glow-el');
      if (!eyes.length) return;
      function blink() {
        eyes.forEach(e => {
          e.style.transform = 'scaleY(0.05)';
          e.style.transformOrigin = 'center';
          setTimeout(() => { e.style.transform = 'scaleY(1)'; }, 100);
        });
        setTimeout(blink, 3000 + Math.random() * 4000);
      }
      setTimeout(blink, 2000);
    }
  };

  /* ── SEARCH ─────────────────────────────────────────────────────── */
  const Search = {
    init() {
      const searchInputs = document.querySelectorAll('.search-input');
      searchInputs.forEach(input => {
        input.addEventListener('keydown', e => {
          if (e.key === 'Enter' && input.value.trim()) {
            window.location.href = `/search?q=${encodeURIComponent(input.value.trim())}`;
          }
        });
      });
    }
  };

  /* ── PUBLIC API ─────────────────────────────────────────────────── */
  return {
    Cart,
    Toast,
    init() {
      Toast.init();
      Cart.init();
      Reveal.init();
      MobileNav.init();
      Wishlist.init();
      Loader.init();
      Parallax.init();
      Carousel.init();
      Gallery.init();
      Variants.init();
      Filters.init();
      Search.init();
      WizardBlink.init();
      // Slight delay for canvas (let DOM paint first)
      setTimeout(() => Particles.init(), 500);
    }
  };
})();

document.addEventListener('DOMContentLoaded', () => window.RadgeTheme.init());
